import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';

const LanguageToggle = ({
    size = 'small',
    color = 'primary',
}) => {
    const { i18n } = useTranslation();
    const [lang, setLang] = useState(i18n.language || 'en');

    const handleLangChange = (event, newLang) => {
        if (newLang) {
            i18n.changeLanguage(newLang);
            setLang(newLang);
        }
    };

    const languages = {
        en: { nativeName: 'English' },
        es: { nativeName: 'Spanish' },
    };

    return (
        <ToggleButtonGroup
            value={lang}
            exclusive
            onChange={handleLangChange}
            size={size}
            color={color}
        >
            {Object.keys(languages).map(langKey => (
                <ToggleButton value={langKey} key={langKey}>
                    {/* {languages[langKey].nativeName} */}
                    {langKey}
                </ToggleButton>
            ))}
        </ToggleButtonGroup>
    );
};

export default LanguageToggle;